import styled from "@emotion/styled";

export const MainBlock = styled.div`
  padding-block: 60px 30px;
  height: 100%;
`
